<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="2" :stroke="color" stroke-width="1.5" />
    <circle cx="10" cy="4" r="2" :stroke="color" stroke-width="1.5" />
    <circle cx="14" cy="6" r="2" :stroke="color" stroke-width="1.5" />
    <circle cx="16" cy="10" r="2" :stroke="color" stroke-width="1.5" />
    <circle cx="14" cy="14" r="2" :stroke="color" stroke-width="1.5" />
    <circle cx="18" cy="18" r="3" :stroke="color" stroke-width="1.5" />
    <path
      d="M8 6L6 8"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12 5L14 7"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M15 8L15 10"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M15 12L15 14"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M15.5 15.5L16 16.5"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
